module.exports = __webpack_public_path__ + "img/user-circle.47078676.svg";